<div
  class="layout-sidebar"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>
  <div class="sidebar-header">
    <a [routerLink]="['/']">
      <img src="assets/layout/images/logo.png" alt="logo" width="160px" />
    </a>
    <button
      class="layout-sidebar-anchor p-link z-2 mb-2"
      type="button"
      (click)="anchor()"
    ></button>
  </div>

  <div #menuContainer class="layout-menu-container">
    <app-menu></app-menu>
  </div>

  <div class="sidebar-footer" style="padding: 0.5rem">
    <img
      src="assets/layout/images/eu_next_gen_vertical.png"
      alt="logo"
      width="110px"
    />
  </div>
</div>
